import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  table: {
    maxHeight: 500,
    marginBottom: '20px',
    borderRadius: 0
  },
  heading: {
    color: '#335977;',
    fontSize: '20px',
    marginBottom: '10px',
    marginTop: '10px'
  },
  spacing: {
  },
  tableHeader: {
    border: 'none',
    backgroundColor: '#335977',
    fontSize: '14px',
    letterSpacing: '0.07px',
    fontFamily: 'Roboto, sans-serif',
    whiteSpace: 'nowrap'
  },
  headerWrapper: {
    color: '#FFE784',
    padding: 0
  },
  paginationWrapper: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: '#4A4A4A',
    fontSize: '14px',
    flexWrap: 'wrap',
    '& .MuiInputBase-root': {
      '& svg': {
        '@media (min-width: 3000px)': {
          top: 'calc(50% - 25px)'
        }
      }
    }
  },
  paginationSelectWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  selectRoot: {
    width: '50px',
  },
  selectWrapper: {
    margin: '0 10px 0 20px'
  },
  sortIcon: {
    color: '#FFFFFF',
    marginLeft: '2px'
  },
  noPointer: {
    pointerEvents: 'none'
  },
  tableHeading: {
    '& span': {
      fontSize: '14px'
    },
  },
  dropDownValues: {
    cursor: 'pointer',
    padding: '8px 12px',
    fontSize: '14px'
  },
  popoverPaper: {
    width: '200px',
  },
  active: {
    backgroundColor: '#D6D1CE',
    margin: '3px',
    borderRadius: '8px',
    color: '#000000',
    fontWeight: 'bold'
  },
  tableHead: {
    background: '#335977'
  },
  infoIcon: {
    fontSize: '14px',
    cursor: 'pointer'
  },
  infoPopover: {
    color: '#4A4A4A',
    fontSize: '14px',
    opacity: '70%',
    textAlign: 'left',
  },
  infoPopoverPaper: {
    width: '250px'
  },
  rowsWrapper: {
    display: 'flex', 
    justifyContent: 'space-between', 
    width: '80%'
  },
  addSiteWrapper: {
    display: 'flex', 
    justifyContent: 'space-between', 
    width:'250px'
  },
  addingSiteLoader: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-10px',
    marginLeft: '-10px'
  }
})

export { useStyles }